import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 16px;
  width: 100%;

  & .MuiTab-wrapper {
    font-family: "Inter", sans-serif;
    text-transform: capitalize;
    color: ${({ theme }) => theme.palette.greyscale.grey800};
    font-size: ${16 / 16}rem;
  }

  & .Mui-selected {
    font-weight: 600;
  }

  & .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.greyscale.grey800};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    //margin-top: 40px;
  }
`;